export const CONFIG = {
  mode: "random", // or "spaced"
  maxSessionCards: 100,
  maxActivePoolSize: 100,
  randomisation: "shuffle",
  unlockThreshold: 3,
  initialUnlockedCount: 200,
  delayScale: {
    perWord: 0.75,
    perLetter: 0.15,
    betweenCards: 2,
  },
  showDebugStats: true,
  autoMode: false,
};
